export const lph_1 = {
	lph_1_1: require('@/assets/images/lph/1/1.png'),
	lph_1_2: require('@/assets/images/lph/1/2.png'),
	lph_1_3: require('@/assets/images/lph/1/3.png'),
	lph_1_4: require('@/assets/images/lph/1/4.png'),
	lph_1_5: require('@/assets/images/lph/1/5.png'),
};

export const lph_2 = {
	lph_2_1: require('@/assets/images/lph/2/1.png'),
	lph_2_2: require('@/assets/images/lph/2/2.png'),
	lph_2_3: require('@/assets/images/lph/2/3.png'),
	lph_2_4: require('@/assets/images/lph/2/4.png'),
};

export const lph_3 = {
	lph_3_1: require('@/assets/images/lph/3/1.png'),
	lph_3_2: require('@/assets/images/lph/3/2.png'),
	lph_3_3: require('@/assets/images/lph/3/3.png'),
	lph_3_4: require('@/assets/images/lph/3/4.png'),
	lph_3_5: require('@/assets/images/lph/3/5.png'),
}

export const lph_4 = {
	lph_4_1: require('@/assets/images/lph/4/1.png'),
	lph_4_2: require('@/assets/images/lph/4/2.png'),
	lph_4_3: require('@/assets/images/lph/4/3.png'),
	lph_4_4: require('@/assets/images/lph/4/4.png'),
	lph_4_5: require('@/assets/images/lph/4/5.png'),
}

export const lph_5 = {
	lph_5_1: require('@/assets/images/lph/5/1.png'),
	lph_5_2: require('@/assets/images/lph/5/2.png'),
	lph_5_3: require('@/assets/images/lph/5/3.png'),
}

export const lph_6 = {
	lph_6_1: require('@/assets/images/lph/6/1.png'),
	lph_6_2: require('@/assets/images/lph/6/2.png'),
	lph_6_3: require('@/assets/images/lph/6/3.png'),
}

export const lph_7 = {
	lph_7_1: require('@/assets/images/lph/7/1.png'),
	lph_7_2: require('@/assets/images/lph/7/2.png'),
	lph_7_3: require('@/assets/images/lph/7/3.png'),
	lph_7_4: require('@/assets/images/lph/7/4.png'),
	lph_7_5: require('@/assets/images/lph/7/5.png'),
	lph_7_6: require('@/assets/images/lph/7/6.png'),
	lph_7_7: require('@/assets/images/lph/7/7.png'),
}

export const lph_8 = {
	lph_8_1: require('@/assets/images/lph/8/1.png'),
	lph_8_2: require('@/assets/images/lph/8/2.png'),
	lph_8_3: require('@/assets/images/lph/8/3.png'),
}
